var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { loadImage } from './loadImage';
import { EXPORT_SCALE, INSTAGRAM_HEIGHT, INSTAGRAM_WIDTH } from './types';
export function renderImageCover(url_1) {
    return __awaiter(this, arguments, Promise, function (url, width, height) {
        var image, canvas, ctx, scale, drawWidth, drawHeight, offsetX, offsetY;
        if (width === void 0) { width = INSTAGRAM_WIDTH; }
        if (height === void 0) { height = INSTAGRAM_HEIGHT; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, loadImage(url)];
                case 1:
                    image = _a.sent();
                    canvas = document.createElement('canvas');
                    canvas.width = width * EXPORT_SCALE;
                    canvas.height = height * EXPORT_SCALE;
                    ctx = canvas.getContext('2d');
                    if (!ctx) {
                        throw new Error('Canvas context unavailable');
                    }
                    ctx.scale(EXPORT_SCALE, EXPORT_SCALE);
                    ctx.imageSmoothingEnabled = true;
                    ctx.imageSmoothingQuality = 'high';
                    scale = Math.max(width / image.width, height / image.height);
                    drawWidth = image.width * scale;
                    drawHeight = image.height * scale;
                    offsetX = (width - drawWidth) / 2;
                    offsetY = (height - drawHeight) / 2;
                    ctx.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);
                    return [2 /*return*/, canvasToBlob(canvas)];
            }
        });
    });
}
function canvasToBlob(canvas) {
    return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
            if (blob) {
                resolve(blob);
            }
            else {
                reject(new Error('Failed to export canvas'));
            }
        }, 'image/png');
    });
}
